export default __webpack_public_path__ + "static/logo_card-816b44903b187c75b85a364de823581d.png";